import React from 'react'
import { ProfileProps } from './Profile.types'
import { IconLogout, IconProfile } from 'assets'
import { User } from 'utilities'
import { HeaderProfile } from '@touche-lts/panel-ui/dist'
import { inject } from 'mobx-react'
import { GENERAL_STORE, ROUTING_STORE } from 'store'
import { observer } from 'mobx-react-lite'

const ProfileComponent = (props: ProfileProps) => {
  const {
    className,
    style,
    [ROUTING_STORE]: { push },
    [GENERAL_STORE]: {
      rootStore: { clearStores }
    }
  } = props

  return (
    <HeaderProfile
      className={className}
      style={style as any}
      iconProfile={IconProfile as any}
      isUserAuthenticated={User.isAuthenticated()}
      profileMenu={[
        {
          label: 'My profile',
          icon: IconProfile as any,
          onClick: () => push('/user-management/my-profile')
        },
        {
          label: 'Log out',
          icon: IconLogout,
          onClick: () => {
            clearStores()
            window.localStorage.clear()
            push('/login')
          }
        }
      ]}
    />
  )
}

const Profile = inject(ROUTING_STORE, GENERAL_STORE)(observer(ProfileComponent))
export { Profile }
